import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import ProfileLogo from '@hellodarwin/core/lib/components/provider/profile/profile-assets/profile-logo';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import Badge from 'antd/es/badge';
import { UserMenuButtonStyled } from './styles';
const UserMenuButton = ({ withArrow, user, onClick, isOnNav, notifs, }) => {
    var _a, _b;
    const { app } = usePlatform();
    const styledProps = {
        $isOnNav: isOnNav,
        $app: app,
    };
    if (!user) {
        return (_jsx(UserMenuButtonStyled, Object.assign({}, styledProps, { onClick: onClick, children: withArrow && _jsx(TabArrow, { down: true, size: 12 }) })));
    }
    const profileLogo = (_jsx(ProfileLogo, { logo: user.logo, size: 28, name: (_a = user.name) !== null && _a !== void 0 ? _a : user.email, type: app !== 'website' ? app : 'provider' }));
    return (_jsxs(UserMenuButtonStyled, Object.assign({}, styledProps, { onClick: onClick, children: [!!notifs && notifs > 0 ? (_jsx(Badge, { count: notifs, size: "small", offset: [-2, 6], children: profileLogo })) : (profileLogo), _jsx(Typography, { nowrap: true, ellipsis: true, medium: true, elementTheme: "body3", style: { margin: '0px 6px 0px 8px', width: 'fit-content' }, children: (_b = user === null || user === void 0 ? void 0 : user.name) !== null && _b !== void 0 ? _b : user === null || user === void 0 ? void 0 : user.email }), withArrow && _jsx(TabArrow, { down: true, size: 12 })] })));
};
export default UserMenuButton;
